import {
    RaikoBaseCardContainer,
    RaikoGridOneColumn, RaikoLabel,
    RaikoSectionContainer,
    RaikoToggleOutlined, showServerErrorMessage, showSuccessMessage, showWarningMessage
} from "@moeindal/base-raiko-panel-components";
import React, {useEffect, useState} from "react";
import {LoadingHelper} from "../../../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../../../context/LoadingContext";
import RaikoBaseDialogContentContainer
    from "../../../../raikoComponents/raikoBaseDialogContentContainer/RaikoBaseDialogContentContainer";

export default function PredefinedAvatarDetailsStatus({service, predefinedAvatarId}) {

    const [published, setPublished] = useState(false);
    const [publishStateLoading, setPublishStateLoading] = useState(false);

    const loading = new LoadingHelper(useLoadingDispatcher())

    useEffect(() => {
        if (typeof service !== "undefined") {
            getPredefinedAvatarDetailsStatusFromServer()
        }
    }, []);

    function getPredefinedAvatarDetailsStatusFromServer() {
        loading.show()
        service.getPredefinedAvatarStatus(predefinedAvatarId)
            .then(response => {
                setPublished(response.enabled)
            }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(_ => {
            loading.hide()
        })
    }

    function handleUpdatePredefinedAvatarStatus() {
        setPublishStateLoading(true)
        service.updatePredefinedAvatarStatus(predefinedAvatarId, published)
            .then(response => {
                if (published)
                    showSuccessMessage("انتشار آواتار با موفقیت انجام شد.")
                else
                    showWarningMessage("وضعیت انتشار به پیش نویس تغییر پیدا کرد.")
            }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(_ => {
            setPublishStateLoading(false)
        })

    }


    return (
        <RaikoBaseCardContainer>
            <RaikoSectionContainer
                title={"وضعیت انتشار"}
                subTitle={"تغییر وضعیت انتشار برای مشاهده ی آواتار توسط کاربران"}
                hasHelperButton
                helperTitle={"وضعیت انتشار"}
                helperContent={
                    <RaikoBaseDialogContentContainer>
                        <RaikoLabel
                            text={"آواتار در ابتدا به صورت پیش نویس قرار خواهد گرفت و فقط توسط ادمین در پنل مدیریت قابل مشاهده و ویرایش خواهد بود."}/>
                        <RaikoLabel
                            text={"برای مشاهده ی آواتار توسط کاربران می بایست وضعیت انتشار را از روی پیش نویس به منتشر شده تغییر دهید."}/>
                        <RaikoLabel
                            text={"⚠️قبل از انتشار آواتار حتما از صحت اطلاعات و تکمیل بودن همه ی قسمت ها اطمینان حاصل نمایید!"}/>
                    </RaikoBaseDialogContentContainer>
                }
                hasActionButton
                actionButtonLoadingState={publishStateLoading}
                actionButtonOnclick={handleUpdatePredefinedAvatarStatus}
            >
                <RaikoGridOneColumn>
                    <RaikoToggleOutlined
                        checked={published}
                        setChecked={setPublished}
                        labelText={"منتشر شده /  پیش نویس"}
                    />
                </RaikoGridOneColumn>
            </RaikoSectionContainer>
        </RaikoBaseCardContainer>
    )
}